"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.oneYear = exports.oneMonth = exports.oneWeek = exports.oneDay = exports.oneHour = exports.oneMinute = exports.oneSecond = exports.Duration = void 0;
exports.showDuration = showDuration;
const zod_1 = require("zod");
exports.Duration = zod_1.z.number(); // in millis
exports.oneSecond = 1000;
exports.oneMinute = 60 * exports.oneSecond;
exports.oneHour = 60 * exports.oneMinute;
exports.oneDay = 24 * exports.oneHour;
exports.oneWeek = 7 * exports.oneDay;
exports.oneMonth = 30 * exports.oneDay;
exports.oneYear = 365 * exports.oneDay;
function showDuration(millis) {
    if (millis > 2 * 365 * 24 * 60 * 60 * 1000) {
        return `${Math.round(millis / 1000 / 60 / 60 / 24 / 365)} years`;
    }
    else if (millis > 2 * 30 * 24 * 60 * 60 * 1000) {
        return `${Math.round(millis / 1000 / 60 / 60 / 24 / 30)} months`;
    }
    else if (millis > 2 * 7 * 24 * 60 * 60 * 1000) {
        return `${Math.round(millis / 1000 / 60 / 60 / 24 / 7)} weeks`;
    }
    else if (millis > 2 * 24 * 60 * 60 * 1000) {
        return `${Math.round(millis / 1000 / 60 / 60 / 24)} days`;
    }
    else if (millis > 2 * 60 * 60 * 1000) {
        return `${Math.round(millis / 1000 / 60 / 60)} hours`;
    }
    else if (millis > 2 * 60 * 1000) {
        return `${Math.round(millis / 1000 / 60)} mins`;
    }
    else if (millis > 10 * 1000) {
        return `${Math.round(millis / 1000)} secs`;
    }
    else {
        return `${Math.round(millis)} ms`;
    }
}
//# sourceMappingURL=duration.js.map